module.exports = __webpack_public_path__ + "img/state-of-survival.8ff0d62.jpg";